var EProductPlanPaymentInterval;
(function(EProductPlanPaymentInterval) {
    EProductPlanPaymentInterval["OneTime"] = "oneTime";
    EProductPlanPaymentInterval["Daily"] = "daily";
    EProductPlanPaymentInterval["Monthly"] = "monthly";
    EProductPlanPaymentInterval["Quarterly"] = "quarterly";
    EProductPlanPaymentInterval["HalfYearly"] = "halfYearly";
    EProductPlanPaymentInterval["Yearly"] = "yearly";
})(EProductPlanPaymentInterval || (EProductPlanPaymentInterval = {}));
var EProductPlanVisibility;
(function(EProductPlanVisibility) {
    EProductPlanVisibility["Public"] = "public";
    EProductPlanVisibility["Private"] = "private";
})(EProductPlanVisibility || (EProductPlanVisibility = {}));
export { EProductPlanPaymentInterval, EProductPlanVisibility };
